
import {
	DBxEvent
} from "cartovista";
import ZoomLayeringLocal from "cartovistaExtend/layers/ZoomLayeringLocal";
import {createLayer} from "cartovistaExtend/utils/CvUtils";

    export function createLayers() {
        var map = window.cartovista.getMap(C.MAP.ID);
        _.forEach(C.LAYERS, function(layerConfig) {
            var layer = createLayer(layerConfig),
                index = typeof layerConfig.INDEX != "undefined" ? layerConfig.INDEX : map.layers.length;
            map.addLayerAt(layer, index);
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_layerCreated", {"layer": layer}));
        });
        window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
    };

    export function initZoomLayeringLayers() {
        var zlLayersConfigs = C.APP_TOOLS.ZOOM_LAYERING;
        _.forEach(zlLayersConfigs, function(layerConfig) {
            new ZoomLayeringLocal(layerConfig);
        });

    };
